module.exports = __webpack_public_path__ + "assets/img/home3-box3-img4.14982e52.png";